import React from 'react';
import Header from './Header';
import Ticker from './Ticker';

const Nav = () => {
  return (
    <>
      <Ticker />
      <nav 
        className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm py-3 border-bottom"
        style={{ zIndex: 1030 }} // Ensures header overlays page elements while scrolling
      >
        <div className="container">
          <a className="navbar-brand d-flex align-items-center gap-2" href="/">
            <img src="/assets/img/lagos-logo.png" alt="Lagos State Seal" style={{ height: '45px' }} />
            <img src="/assets/img/logo-alt.png" alt="Eko360 Logo" style={{ height: '38px' }} />
          </a>
          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navmenu"
            aria-controls="navmenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <Header />
        </div>
      </nav>
    </>
  );
};

export default Nav;